import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {

    getNotifications(): Observable<any> {
        return of([
            {
                id: 1,
                title: 'Trademark Renewal Due',
                description: "Your trademark registration is expiring soon and requires renewal action.",
                author: "INNOVATE PRO - Trademark Registration",
                status: "",
                date: "20/11/2025",
                isRead: false
            },
            {
                id: 2,
                title: 'Patent Expiration Notice',
                description: "Your patent is approaching its expiration date. Review the details and take necessary action.",
                author: "Method and System for Advanced Data Encryption",
                status: "",
                date: "17/11/2025",
                isRead: false
            },
            {
                id: 3,
                title: 'Change of Ownership',
                description: "Your trademark registration is expiring soon and requires renewal action.",
                author: "INNOVATE PRO - Trademark Registration",
                status: "Approval Pending",
                date: "15/11/2025",
                isRead: false
            },
            {
                id: 4,
                title: 'GI Registration',
                description: "Your Geographical Indication registration has been successfully renewed.",
                author: "Napa Valley - Geographical Indication",
                status: "Renewal Confirmed",
                date: "10/11/2025",
                isRead: false
            },
            {
                id: 5,
                title: 'GI Registration 1',
                description: "Your Geographical Indication registration has been successfully renewed.",
                author: "Napa Valley - Geographical Indication",
                status: "Renewal Confirmed",
                date: "10/11/2025",
                isRead: false
            },
        ])
    }
}